/**
 * State used in rendering TeachingPopoverCarouselFooterButton
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
